import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setUser, setToken } from '../../redux/actions';
import { url, history } from '../../utils/variables';
import LoginComponent from '../../components/master/LoginComponent';
// import header from '../../assets/images/header.png';
import header from '../../assets/images/header1.png';
import logo from '../../assets/images/logo.png';
// import loginFooter from '../../assets/images/loginFooter.png';
import loginFooter from '../../assets/images/footer1.png';
import GolrangeLogo from '../../assets/images/g3se0(2).png';
import { useTranslation } from 'react-i18next';
// import BalonLogo from '../../assets/images/balon-logo2.png'
import BalonLogo from '../../assets/images/logo/ballon-logo.svg'
import WhiteBalonLogo from '../../assets/images/logo/white-logo.svg'


export default function Login() {

    const { i18n } = useTranslation();
    const location = useLocation();
    const insuranceLogo = location.search && location.search.replace('?', '');

    const dispatch = useDispatch();

    function getData(data) {
        dispatch(setUser(data.user));
        dispatch(setToken(data.token));
        // history.replace('/');
        history.replace('/?login=true');
    }
    //*
     const { user , theme , insuranceCode} = useSelector(store => store);
     const [ad,setAd] = useState(true)
    useEffect(()=>{
        // const check = ()=>{
        //     if(user.type)
        //         history.replace('/');
        // }
        // check();
        !user.type && i18n.changeLanguage('fa');
        user.type && history.replace('/');
        let adOff = ''
        if(insuranceLogo) {
            adOff = setTimeout(() => setAd(false), 3000);
        }
        return(()=> {
            clearTimeout(adOff)
        })
    },[user,insuranceLogo])

    return (
        <div className='login'>
            {/* <img src={header} alt='header' className='headerImage'/> */}
            {insuranceLogo && ad && 
                <div className='advertisment'><img src={`${url}/images/insurances/app-flag/${insuranceLogo}`} className='insuranceImages' alt='logo'/></div>
            }
            <div className='content'>
                <div className='text-center'>
                    {
                        // insuranceLogo
                        //     ? <img src={`${url}/images/insurances/header/${insuranceLogo}.png`} className='insuranceImages' alt='logo'/>
                        //     : 
                        insuranceCode ?
                            <img src={`${url}/images/insurances/app-flag/${insuranceCode}_login.png`} className='insuranceLogo' alt='logo'/>
                        :
                            <img src={theme === 'light' ? BalonLogo:WhiteBalonLogo} alt='logo' className='logo'/>
                    }
                    <div className='mt20'>
                        <LoginComponent
                            getData={getData}
                        />
                    </div>
                    {/* {
                        insuranceLogo === 'g3se0'
                        ?
                        <div className='logoSlide'>
                            <img className='mt30 ' src={GolrangeLogo} alt='logo'/>  
                        </div>
                        :
                        insuranceLogo &&
                        <img className='mt30 insuranceImages' src={`${url}/images/insurances/footer/${insuranceLogo}.png`} alt='logo'/>
                    } */}

                    {/* <div className='text-center version'>
                        <h6 style={{color:"#ada6a6"}}>3.0.9</h6>
                    </div> */}
                </div>
            </div>
            {/* <img src={loginFooter} alt='header' className='headerImage'/> */}
        </div>
    );

}
